export abstract class AbstractDTO {}